type AdministratorsModule = typeof import("../features/administration/administrators-page");
type AuditModule = typeof import("../features/audit/audit-page");
type LegalModule = typeof import("../features/legal/legal-pages");
type PartnersModule = typeof import("../features/partners/partners-page");
type UsersModule = typeof import("../features/users/users-page");

let administratorsModule: AdministratorsModule | undefined;
let administratorsPromise: Promise<AdministratorsModule> | undefined;
let auditModule: AuditModule | undefined;
let auditPromise: Promise<AuditModule> | undefined;
let legalModule: LegalModule | undefined;
let legalPromise: Promise<LegalModule> | undefined;
let partnersModule: PartnersModule | undefined;
let partnersPromise: Promise<PartnersModule> | undefined;
let usersModule: UsersModule | undefined;
let usersPromise: Promise<UsersModule> | undefined;

export function loadAdministratorsPage(): Promise<AdministratorsModule> {
  administratorsPromise ??= import("../features/administration/administrators-page")
    .then((module) => {
      administratorsModule = module;
      return module;
    })
    .catch((error) => {
      administratorsPromise = undefined;
      throw error;
    });
  return administratorsPromise;
}

export function loadAuditPage(): Promise<AuditModule> {
  auditPromise ??= import("../features/audit/audit-page")
    .then((module) => {
      auditModule = module;
      return module;
    })
    .catch((error) => {
      auditPromise = undefined;
      throw error;
    });
  return auditPromise;
}

export function loadLegalPages(): Promise<LegalModule> {
  legalPromise ??= import("../features/legal/legal-pages")
    .then((module) => {
      legalModule = module;
      return module;
    })
    .catch((error) => {
      legalPromise = undefined;
      throw error;
    });
  return legalPromise;
}

export function loadPartnersPage(): Promise<PartnersModule> {
  partnersPromise ??= import("../features/partners/partners-page")
    .then((module) => {
      partnersModule = module;
      return module;
    })
    .catch((error) => {
      partnersPromise = undefined;
      throw error;
    });
  return partnersPromise;
}

export function loadUsersPage(): Promise<UsersModule> {
  usersPromise ??= import("../features/users/users-page")
    .then((module) => {
      usersModule = module;
      return module;
    })
    .catch((error) => {
      usersPromise = undefined;
      throw error;
    });
  return usersPromise;
}

export const getAdministratorsPage = () => administratorsModule?.AdministratorsPage;
export const getAuditPage = () => auditModule?.AuditPage;
export const getLegalPage = () => legalModule?.LegalPage;
export const getTermsLegalVersionManagerPage = () => legalModule?.TermsLegalVersionManagerPage;
export const getPartnersPage = () => partnersModule?.PartnersPage;
export const getAdminsPage = () => usersModule?.AdminsPage;
export const getUsersPage = () => usersModule?.UsersPage;
